import React from "react";
import { MoreHorizontal } from "lucide-react";

const TRAILER_IMAGES = {
    reefer: "/equipment/eq_reefer.png",
    dry_van: "/equipment/eq_dry_van.png",
    conestoga: "/equipment/eq_conestoga.png",
    flatbed: "/equipment/eq_flatbed.png",
    step_deck: "/equipment/eq_step_deck.png",
};

const ORDER = ["reefer", "dry_van", "conestoga", "flatbed", "step_deck", "other"];

export function EquipmentTypeCards({ value, onChange, options, disabled, otherText, onOtherTextChange }) {
    const opts = options || [];
    const byValue = Object.fromEntries(opts.map((o) => [o.value, o]));
    const ordered = ORDER.filter((k) => byValue[k]).map((k) => byValue[k]);
    return (
        <div className="space-y-4">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="equipment-type-grid">
                {ordered.map((opt) => {
                    const active = value === opt.value;
                    const imgSrc = TRAILER_IMAGES[opt.value];
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            disabled={disabled}
                            onClick={() => onChange(opt.value)}
                            data-testid={`equipment-card-${opt.value}`}
                            className={`group flex flex-col items-center gap-2 rounded-md border p-4 text-center transition-all ${
                                active
                                    ? "border-blue-900 bg-blue-50 ring-2 ring-blue-900/15 shadow-sm"
                                    : "border-slate-200 bg-white hover:border-slate-300"
                            } disabled:opacity-50 disabled:cursor-not-allowed`}
                        >
                            {imgSrc ? (
                                <div className="flex h-24 sm:h-28 w-full items-center justify-center">
                                    <img
                                        src={imgSrc}
                                        alt={`${opt.label} trailer`}
                                        className="h-full w-auto object-contain"
                                        draggable={false}
                                    />
                                </div>
                            ) : (
                                <div
                                    className={`flex h-24 sm:h-28 w-full items-center justify-center rounded-md ${
                                        active ? "bg-blue-900/5 text-blue-900" : "bg-slate-50 text-slate-500 group-hover:bg-slate-100"
                                    }`}
                                >
                                    <MoreHorizontal size={28} />
                                </div>
                            )}
                            <div className="font-display text-sm font-semibold text-slate-900">{opt.label}</div>
                        </button>
                    );
                })}
            </div>
            {value === "other" && (
                <div className="space-y-2" data-testid="equipment-other-wrapper">
                    <label className="text-sm font-medium text-slate-900">Specify equipment type</label>
                    <input
                        type="text"
                        value={otherText || ""}
                        onChange={(e) => onOtherTextChange(e.target.value)}
                        disabled={disabled}
                        data-testid="equipment-other-input"
                        placeholder="e.g. Lowboy"
                        className="flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-900/30"
                    />
                </div>
            )}
        </div>
    );
}
